<template>
    <Header12 />
    <div class="body">
        <section class="background-rose">
            <MenuTitle title="Nos centres" srcImg="/images/pages/bilan-competences/menu_title.jpg"
                backgroundSpan="span-background-red" />
        </section>
        <section>
            <div class="container pt-50 d-flex">
                <div class="position-relative w-50 desktop">
                    <nuxt-img src="/images/pages/bilan-competences/carte-south-france.png"></nuxt-img>
                    <div v-for="point in points" :key="point.id" class="box-point">
                        <a href="#">
                            <img :id="'point-' + point.id" class="point" :src="point.img" :alt="point.title" :style="{
                        position: 'absolute',
                        top: point.coordY + 'px',
                        left: point.coordX + 'px',
                    }">
                        </a>
                    </div>
                </div>
                <div class="w-50">
                    <div v-for="point in points" :key="point.id" class="cityName">
                        <span class="d-flex gap-2">
                            <i class="fa-solid fa-plus"></i>
                            <i class="fa-solid fa-minus"></i>
                            {{ point.title }}
                        </span>
                        <div class="position-relative moreInfoCity">
                            <div class="infoCity">
                                <p class="pb-3">{{ point.address }}</p>
                                <p class="pb-3">{{ point.phone }}</p>
                                <div class="d-sm-flex align-items-center button-group gap-3">
                                    <a :href="'tel:' + point.phone" class="d-flex align-items-center contact">
                                        Joindre le centre
                                        <i class="fa-solid fa-phone"></i>
                                    </a>
                                    <a href="mailto:info@emciconseil.com" class="d-flex align-items-center contact">
                                        Envoyer un mail
                                        <i class="fa-solid fa-envelope"></i>
                                    </a>
                                </div>
                            </div>
                            <div class="imgPoint">
                                <nuxt-img :src="point.backgroundImg"></nuxt-img>
                            </div>
                        </div>
                    </div>
                    <div class="cityName">
                        <span class="d-flex gap-2">
                            <i class="fa-solid fa-plus"></i>
                            <i class="fa-solid fa-minus"></i>
                            PARIS
                        </span>
                        <div class="position-relative moreInfoCity">
                            <div class="infoCity">
                                <p class="pb-3">45 rue Liancourt, 75014 Paris</p>
                                <p class="pb-3">05 62 47 19 09</p>
                                <div class="d-sm-flex align-items-center button-group gap-3">
                                    <a href="tel:05 62 47 19 09" class="d-flex align-items-center contact">
                                        Joindre le centre
                                        <i class="fa-solid fa-phone"></i>
                                    </a>
                                    <a href="mailto:info@emciconseil.com"
                                        class="d-flex align-items-center contact">Envoyer un mail<i
                                            class="fa-solid fa-envelope"></i>
                                    </a>
                                </div>
                            </div>
                            <div class="imgPoint">
                                <nuxt-img src="/images/pages/bilan-competences/centres/paris.jpeg"></nuxt-img>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section>
            <NousContacter />
        </section>
        <section>
            <Footer :dark_bg="true" />
        </section>
    </div>
</template>
<script setup>
import Header12 from '~/components/common/Headers/Header-12.vue';
import MenuTitle from "@/components/emci/MenuTitle";
import NousContacter from '@/components/emci/NousContacter/index.vue'
import Footer from '@/components/emci/Footer/index.vue'

const points = ref([
    {
        id: 1,
        img: '/images/pages/accueil/icon-point.png',
        backgroundImg: '/images/pages/bilan-competences/centres/voir-plus_9.png',
        address: '43-45 rue d’Armagnac, 33800 Bordeaux',
        phone: '05 62 47 19 09',
        title: 'BORDEAUX',
        coordY: '327',
        coordX: '109',
        link: "",
    },
    {
        id: 2,
        img: '/images/pages/accueil/icon-point.png',
        backgroundImg: '/images/pages/bilan-competences/centres/voir-plus_5.png',
        address: '6 rue Paul Bert, 46 100 FIGEAC',
        phone: '05 62 47 19 09',
        title: 'FIGEAC',
        coordY: '360',
        coordX: '358',
        link: "",
    },
    {
        id: 4,
        img: '/images/pages/accueil/icon-point.png',
        backgroundImg: '/images/pages/bilan-competences/centres/voir-plus_8.png',
        address: '125 Rue de l\'Hostellerie, 30900 Nîmes',
        phone: '05 62 47 19 09',
        title: 'NIMES',
        coordY: '475',
        coordX: '606',
        link: "",
    },
    {
        id: 5,
        img: '/images/pages/accueil/icon-point.png',
        backgroundImg: '/images/pages/bilan-competences/centres/voir-plus_1.png',
        address: '42 Boulevard Carnot, 81 000 ALBI',
        phone: '05 62 47 19 09',
        title: 'ALBI',
        coordY: '459',
        coordX: '370',
        link: "",
    },
    {
        id: 6,
        img: '/images/pages/accueil/icon-point.png',
        backgroundImg: '/images/pages/bilan-competences/centres/voir-plus_2.png',
        address: '1 rue Roger Carpentier, 31 700 BLAGNAC',
        phone: '05 62 47 19 09',
        title: 'BLAGNAC',
        coordY: '490',
        coordX: '303',
        link: "",
    },

    {
        id: 7,
        img: '/images/pages/accueil/icon-point.png',
        backgroundImg: '/images/pages/bilan-competences/centres/voir-plus_6.png',
        address: '2 rue Clément Marot, 46 000 CAHORS',
        phone: '05 62 47 19 09',
        title: 'CAHORS',
        coordY: '369',
        coordX: '319',
        link: "",
    },
    {
        id: 8,
        img: '/images/pages/accueil/icon-point.png',
        backgroundImg: '/images/pages/bilan-competences/centres/voir-plus_4.png',
        address: '2 Avenue Mercure 31120 Quint-Fonsegrives',
        phone: '05 62 47 19 09',
        title: 'QUINT-FONSEGRIVES',
        coordY: '522',
        coordX: '376',
        link: "",
    },
    {
        id: 9,
        img: '/images/pages/accueil/icon-point.png',
        backgroundImg: '/images/pages/bilan-competences/centres/voir-plus_10.png',
        address: 'Rue Maryam Mirzakhani, 34000 Montpellier',
        phone: '05 62 47 19 09',
        title: 'MONTPELLIER',
        coordY: '491',
        coordX: '539',
        link: "",
    },
    {
        id: 10,
        img: '/images/pages/accueil/icon-point.png',
        backgroundImg: '/images/pages/bilan-competences/centres/voir-plus_3.png',
        address: 'Pépinière d\'entreprises ZA Albasud 35 Avenue du Danemark, 82 000 Montauban',
        phone: '05 62 47 19 09',
        title: 'MONTAUBAN',
        coordY: '432',
        coordX: '280',
        link: "",
    },
    {
        id: 11,
        img: '/images/pages/accueil/icon-point.png',
        backgroundImg: '/images/pages/bilan-competences/centres/voir-plus.png',
        address: 'Hélios 3 - 116 Route d\'Espagne, 31100 Toulouse',
        phone: '05 62 47 19 09',
        title: 'TOULOUSE',
        coordY: '512',
        coordX: '331',
        link: "",
    }
]);

onMounted(() => {
    points.value.forEach(point => {
        const id = point.id;
        const content = point.title;

        // Créez le tooltip pour chaque point en utilisant son ID comme sélecteur
        tippy(`#point-${id}`, {
            content: content,
        });
    });
})

useHead({
    title: "Réalisez un bilan de compétences dans un des 10 centres de bilan EMCI",
    meta: [
        {
            name: "description",
            content: "Paris, Toulouse,  Montpellier, Bordeaux...trouver le centre le plus proche de chez vous pour réaliser votre bilan de compétences"
        }
    ]
})
</script>
<style scoped>
.desktop {
    display: block;
}

.body {
    overflow: hidden !important;
    margin-top: 120px;
}

.cityName {
    font-family: Nunito;
    font-size: 29px;
    font-style: normal;
    font-weight: 500;
    line-height: 111.5%;
    /* 32.335px */
    letter-spacing: -0.435px;
    border-bottom: 2px solid #EEF5FA;
    padding: 20px;
}

.fa-plus {
    color: #E94B54;
    font-weight: 400;
}

.fa-minus {
    color: #E94B54;
    display: none;
}

.cityName:hover .fa-minus {
    display: block;
}

.cityName:hover .fa-plus {
    display: none;
}

.imgPoint img {
    height: 231px;
    width: 100%;
    object-fit: cover;
}

.imgPoint::before {
    background: linear-gradient(270deg, rgba(255, 255, 255, 0.00) 0%, #FFF 66.76%);
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
}

.infoCity {
    position: absolute;
    z-index: 1;
    top: 25%;
    left: 0;
}

.infoCity p {
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 144%;
    /* 25.92px */
    letter-spacing: 0.72px;
}

.moreInfoCity {
    display: none;
    transition: all 0.4s;
}

.cityName:hover .moreInfoCity {
    display: block;
}

.contact {
    background-color: var(--bleu-fonce) !important;
    border: 2px solid var(--bleu-fonce);
    color: white !important;
    padding: 10px 20px !important;
    border-radius: 35px !important;
    width: auto !important;
    column-gap: 1rem;
    font-size: 20px;
}

.contact:hover {
    background-color: transparent !important;
    border: 2px solid var(--bleu-fonce) !important;
    color: var(--bleu-fonce) !important;
}

@media screen and (min-width: 200px) and (max-width: 320px) {
    .desktop {
        display: none;
    }

    .w-50 {
        width: 100% !important;
    }

    .moreInfoCity {
        display: block;
        transition: all 0.4s;
    }

    .cityName {
        margin-bottom: 2rem;
        padding: 5px;
    }

    .infoCity {
        top: 15%;
    }

    .cityName .contact {
        margin-bottom: 0.5rem;
    }

    .cityName .contact {
        max-width: 85%;
    }
}

@media screen and (min-width: 321px) and (max-width: 375px) {
    .desktop {
        display: none;
    }

    .w-50 {
        width: 100% !important;
    }

    .moreInfoCity {
        display: block;
        transition: all 0.4s;
    }

    .cityName {
        margin-bottom: 2rem;
        padding: 5px;
    }

    .infoCity {
        top: 15%;
    }

    .cityName .contact {
        margin-bottom: 0.5rem;
    }

    .cityName .contact {
        max-width: 85%;
    }
}

@media screen and (min-width: 376px) and (max-width: 425px) {
    .desktop {
        display: none;
    }

    .w-50 {
        width: 100% !important;
    }

    .cityName {
        margin-bottom: 2rem;
        padding: 5px;
    }

    .infoCity {
        top: 15%;
    }

    .cityName .contact {
        margin-bottom: 0.5rem;
    }

    .cityName .contact {
        max-width: 85%;
    }
}

@media screen and (min-width: 425px) and (max-width: 600px) {
    .desktop {
        display: none;
    }

    .w-50 {
        width: 100% !important;
    }

    .cityName {
        margin-bottom: 2rem;
        padding: 5px;
    }

    .moreInfoCity {
        display: block;
        transition: all 0.4s;
    }

    .infoCity {
        top: 15%;
    }

    .cityName .contact {
        margin-bottom: 0.5rem;
    }

    .cityName .contact {
        max-width: 85%;
    }
}

@media screen and (min-width: 600px) and (max-width: 769px) {
    .desktop {
        display: none;
    }

    .w-50 {
        width: 100% !important;
    }

    .moreInfoCity {
        display: block;
        transition: all 0.4s;
    }

    .cityName {
        margin-bottom: 2rem;
        padding: 5px;
    }

    .infoCity {
        top: 15%;
    }

    .cityName .contact {
        margin-bottom: 0.5rem;
    }

    .cityName .contact {
        max-width: 85%;
    }
}

@media screen and (min-width: 770px) and (max-width: 900px) {
    .desktop {
        display: none;
    }

    .w-50 {
        width: 100% !important;
    }

    .moreInfoCity {
        display: block;
        transition: all 0.4s;
    }

    .cityName {
        margin-bottom: 2rem;
        padding: 5px;
    }

    .infoCity {
        top: 15%;
    }

    .cityName .contact {
        margin-bottom: 0.5rem;
    }

    .cityName .contact {
        max-width: 85%;
    }
}

@media screen and (min-width: 901px) and (max-width: 1024px) {}

@media screen and (min-width: 1024px) and (max-width: 1087px) {}

@media screen and (min-width: 1088px) and (max-width: 1381px) {}
</style>